import { Badge, Flex, Switch, Text, useTheme } from "@chakra-ui/react";
import * as React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import PeopleTag from "../../components/PeopleTag/PeopleTag";
import AdditionalStatuses from "./AdditionalStatuses";
import { ListBullets, SubtitlesSlash, UserGear, UsersFour } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { useRightSidebar } from "../../../../context/RightSidebarContext";
import AnswerExclusionCard from "./AnswerExclusionCard";
import useAirUserRoles from "../../../../utils/AuthUtils";
import { isExcludedFn } from "api/issb/Question";

/**
 * @param {?Object} questionData - Question data Can be null while loading.
 * For bulk actions, questionData is the common values (same for all questions)
 * @param {?array} questionIds - Array of question ids for BulkActions
 */
const ManageAnswer = ({ questionData, questionIds, hideStatuses, hideRelevance }) => {
  if (!questionIds) {
    questionIds = [questionData?.id];
  }
  const { colors } = useTheme();
  const { setRightSidebar } = useRightSidebar();
  const { isAssigned } = useAirUserRoles();

  const [isExcluded, setIsExcluded] = useState(isExcludedFn(questionData));

  useEffect(() => {
    setIsExcluded(isExcludedFn(questionData));
  }, [questionData]);

  const handleExcludeToggle = () => {
    setRightSidebar(
      <AnswerExclusionCard
        questionData={questionData}
        questionIds={questionIds}
        isExcluded={isExcluded}
        setIsExcluded={setIsExcluded}
      />
    );
  };

  return (
    <Flex direction="column" gap={6} className="ManageAnswer">
      <StageTag questionData={questionData} />

      <Flex direction="column" gap={2}>
        <Flex gap={2} align="center">
          <UserGear color={colors.gray[400]} size={18} />
          <Text variant="statusTitle">Owner</Text>
        </Flex>
        <PeopleTag users={[questionData?.owner]} type="owner" questionIds={questionIds} questions={[questionData]} />
      </Flex>

      <Flex direction="column" gap={2}>
        <Flex gap={2} align="center">
          <UsersFour size={18} color={colors.gray[400]} />
          <Text variant="statusTitle">Assignees</Text>
        </Flex>
        <PeopleTag
          type="assignee"
          users={questionData?.assignees}
          questionIds={questionIds}
          questions={[questionData]}
        />
      </Flex>

      {questionData?.entity /* TODO Backend support isn't done yet */ && (
        <Flex direction="column" gap={2}>
          <Flex gap={2} align="center">
            <FaMapMarkerAlt />
            <Text variant="statusTitle">Entity</Text>
          </Flex>
          <Badge px={2} py={1} borderRadius="md" fontSize="body.xxs" colorScheme="gray" width="fit-content">
            {questionData.entity}
          </Badge>
        </Flex>
      )}

      {!hideStatuses && (
        <AdditionalStatuses
          statuses={{
            decisionUsefulness: questionData?.decisionUsefulness,
            sensitivity: questionData?.sensitivity,
            confidence: questionData?.confidence,
            completeness: questionData?.completeness,
          }}
          questionIds={questionIds}
          questions={[questionData]}
        />
      )}

      {!hideRelevance && (
        <Flex direction="column" gap={2}>
          <Flex gap={2} align="center">
            <SubtitlesSlash size={18} color={colors.gray[400]} />
            <Text variant="statusTitle">Relevance</Text>
          </Flex>
          <Flex align="center" mt={2}>
            <Switch size="sm" colorScheme="limeShade" isChecked={isExcluded} onChange={() => handleExcludeToggle()} />
            <Text fontSize="body.xs" ml={2}>
              Exclude
            </Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export function StageTag({ questionData }) {
  const { colors } = useTheme();
  return (
    <Flex direction="column" gap={2}>
      <Flex gap={2} align="center">
        <ListBullets size={18} color={colors.gray[400]} />
        <Text variant="statusTitle">Stage</Text>
      </Flex>
      <Badge
        px={2}
        py={1}
        borderRadius="md"
        fontSize="body.xxs"
        colorScheme="yellow"
        // Should we use the stages colours to match the dashboard?? e.g.
        // bg={colors.stagesFaded[questionData?.stageType]}
        width="fit-content"
      >
        {questionData?.stage}
      </Badge>
    </Flex>
  );
}

export default ManageAnswer;
